import $ from "jquery";

/**
 * TODO
 * - Add support for 'step' property on input
 */

const plusminusClass = "sb_input-number_plus-minus";

function onChange() {
    const currentValue = parseInt($(this).val(), 10);
    const minus = $(this).siblings(
        '.sb_input-number_plus-minus_btn[data-action="decrement"]'
    );
    const plus = $(this).siblings(
        '.sb_input-number_plus-minus_btn[data-action="increment"]'
    );
    const min = parseInt($(this).attr("min"), 10);
    const max = parseInt($(this).attr("max"), 10);

    // Clamp value to min/max
    if (currentValue < min) {
        $(this).val(min);
    } else if (currentValue > max) {
        $(this).val(max);
    }

    const clampedValue = parseInt($(this).val(), 10);

    // Handle decrement button state independently
    if (clampedValue <= min) {
        minus.addClass("s_disabled");
    } else {
        minus.removeClass("s_disabled");
    }

    // Handle increment button state independently
    if (clampedValue >= max) {
        plus.addClass("s_disabled");
    } else {
        plus.removeClass("s_disabled");
    }
}

function initializePlusMinusButtons() {
    $(`.${plusminusClass}`).each(function () {
        const $inputContainer = $(this).find(".ginput_container");
        const $input = $(this).find("input");

        if ($inputContainer.find(".sb_input-number_plus-minus_btn").length) {
            // Already initialized, but still update button states
            $input.each(function () {
                onChange.call(this);
            });
            return;
        }

        $inputContainer
            .prepend(
                '<div class="sb_input-number_plus-minus_btn" data-action="decrement"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="m5.57,13.02v-2.03h12.87v2.03H5.57Z"/></svg></div>'
            )
            .append(
                '<div class="sb_input-number_plus-minus_btn" data-action="increment"><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="m10.98,5.57v5.42h-5.42v2.03h5.42v5.42h2.03v-5.42h5.42v-2.03h-5.42v-5.42h-2.03Z"/></svg></div>'
            );

        $input.on("change", onChange);

        // Set initial button states based on current value and min/max
        $input.each(function () {
            onChange.call(this);
        });
    });

    attachPlusMinusButtonClickEvents();
}

function attachPlusMinusButtonClickEvents() {
    $(".sb_input-number_plus-minus_btn")
        .off("click")
        .on("click", function () {
            const $input = $(this).siblings("input[type='number']");
            const currentValue = parseInt($input.val(), 10);
            const placeholder = parseInt($input.attr("placeholder"), 10);
            let value = currentValue || placeholder || 0;
            const action = $(this).attr("data-action");
            let newVal;

            switch (action) {
                case "increment":
                    newVal = value + 1;
                    $input.val(newVal);
                    break;
                case "decrement":
                    newVal = value - 1;
                    $input.val(newVal);
                    break;
                default:
                    break;
            }

            $input.trigger("change");
        });
}

$(document).on("gform_page_loaded", () => {
    initializePlusMinusButtons();
});

initializePlusMinusButtons();
